/**
 * "Parent workflow" utilizes values to initialize a
 * CreateCardCustomizationRequest to exchange for a customization token needed
 * to complete the onboarding flow.
 *
 * Majority of state management complexity is inside the presentation component
 * itself.
 *
 * @module
 */

import { CreateCardCustomizationRequest } from '@square/dashboard-protos/models/squareup/bizbank/service';
import { SignatureFont } from '@banking/ui/models/common/card-customization';
import { BUSINESS_BANKING_CARD_SIGNATURE_RECT, BUSINESS_BANKING_LOWER_RIGHT_RENDER_STRATEGY } from '@banking/ui/utils/text-renderer';

// State
// =============================================================================

export const INITIAL_STATE = {
  newCustomizationActive: false,
  signatureFont: SignatureFont.AlexBrush,
  signatureText: ''
};

// Action
// =============================================================================

export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["SignatureTextChange"] = "CARD_CUSTOMIZATION_SIGNATURE_TEXT_CHANGE";
  ActionType["SignatureFontChange"] = "CARD_CUSTOMIZATION_SIGNATURE_FONT_CHANGE";
  ActionType["NewCustomizationActiveChange"] = "CARD_CUSTOMIZATION_NEW_CUSTOMIZATION_ACTIVE_CHANGE";
  return ActionType;
}({});
// Action Creators
// -----------------------------------------------------------------------------

export const signatureTextChangeAction = signatureText => ({
  type: ActionType.SignatureTextChange,
  signatureText
});
export const signatureFontChangeAction = signatureFont => ({
  type: ActionType.SignatureFontChange,
  signatureFont
});
export const newCustomizationActiveChangeAction = newCustomizationActive => ({
  type: ActionType.NewCustomizationActiveChange,
  newCustomizationActive
});

// Update
// =============================================================================

export function update(state, action) {
  switch (action.type) {
    case ActionType.SignatureTextChange:
      {
        const {
          signatureText
        } = action;
        return [{
          ...state,
          signatureText
        }, null];
      }
    case ActionType.SignatureFontChange:
      {
        const {
          signatureFont
        } = action;
        return [{
          ...state,
          signatureFont
        }, null];
      }
    case ActionType.NewCustomizationActiveChange:
      {
        const {
          newCustomizationActive
        } = action;
        return [{
          ...state,
          newCustomizationActive
        }, null];
      }
  }
}
export const renderCardCustomization = TextRenderer => customization => customization.newCustomizationActive ? new TextRenderer(100, customization.signatureFont, customization.signatureText, BUSINESS_BANKING_CARD_SIGNATURE_RECT, BUSINESS_BANKING_LOWER_RIGHT_RENDER_STRATEGY).toBytes() : Promise.resolve(undefined);
export const createCardCustomizationRequest = (idempotenceKey, unitToken) => imageBytes => CreateCardCustomizationRequest.create({
  idempotenceKey,
  imageBytes,
  mimeType: imageBytes == null ? undefined : 'image/png',
  unitToken
});